<template>
  <div class="light">
    <div class="header">
      <div class="title">风扇设备列表</div>
      <div class="fast-btn">
        <my-button :state="state" @change="powerSwitch"></my-button>
        <el-dropdown type="primary" @command="changeWind" trigger="click">
          <el-button type="primary">
            风速调节<i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(wind,i) in windArray" :command="wind.value"
                              v-text="wind.name"
                              :key="`wind_${i}`"></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="container">
      <fan :device="d" v-for="(d,i) in extDevices.filter(d=>d.devicetype.key==='fan')" :key="`fan_d_${i}`">
      </fan>
      <round class="empty"></round>
      <round class="empty"></round>
      <round class="empty"></round>
    </div>
  </div>
</template>

<script>
import Fan from '@/components/Fan'
import Round from '@/components/Round'
import MyButton from '@/components/Button'
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import api from '@/model/device'

export default {
  name: 'DeviceFan',
  data () {
    return {
      windArray: [
        {
          'name': '低风',
          'value': 1
        }, {
          'name': '中风',
          'value': 2
        }, {
          'name': '高风',
          'value': 3
        }]
    }
  },
  computed: {
    ...mapState(['extDevices']),
    state () {
      return this.extDevices.filter(e => e.devicetype.key === 'fan').every(l => l.state.state)
    }
  },
  components: {
    MyButton,
    Fan,
    Round
  },
  methods: {
    async powerSwitch () {
      try {
        await api.batchControl(['fan'], this.state ? 'close' : 'open')
        // this.state = !this.state
      } catch (e) {
        Message.error(e.message)
      }
    },
    async changeWind (value) {
      try {
        await api.batchControl(['fan'], value === 1 ? 'low' : value === 2 ? 'medium' : 'high')
      } catch (e) {
        Message.error(e.message)
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/base";

.light {
  display: flex;
  flex-direction: column;
  flex: 1;
  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    > .title {
      font-size: 17px;
      font-weight: 600;
      color: rgba(38, 38, 38, 1);
    }
    > .fast-btn {
      display: flex;
      align-items: center;
    }
  }
  > .container {
    overflow-y: auto;
    margin-top: 5px;
    flex: 1;
    height: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      margin-top: 20px;
    }
  }
}
</style>
